"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterButtons = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var FooterButtons = function (_a) {
    var save = _a.save, closeModal = _a.closeModal;
    return (React.createElement(React.Fragment, null,
        React.createElement(sok_ui_1.Button, { color: "green", iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-piggy-bank' }), onClick: save }, (0, translation_1.getLocalization)('buttons/save')),
        React.createElement(sok_ui_1.Button, { color: "near-black", iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-times-circle' }), onClick: closeModal }, (0, translation_1.getLocalization)('buttons/close'))));
};
exports.FooterButtons = FooterButtons;
